<template>
  <div>
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog v-model="detailModal" width="600">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-2">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-information</v-icon>
              <span class="modal-title-text mr-2">جزئیات</span>
              <v-spacer></v-spacer>
              <v-icon class="ml-3" @click="closeDetailModal()">mdi-close</v-icon>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text>
          <v-row>
            <v-col cols="6" class="mt-4">
              <v-card class="card-info-send-mission" elevation="0" height="5vh">
                <v-card-text>
                  <v-row>
                    <span class="mt-1 send-mission-info-title-content">تاریخ:</span>
                    <span class="mr-2 mt-1 send-mission-info-text-content">
                      {{ detailObject?.date }}
                    </span>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6" class="mt-4">
              <v-card class="card-info-send-mission" elevation="0" height="5vh">
                <v-card-text>
                  <v-row>
                    <span class="mt-1 send-mission-info-title-content">کد آمبولانس:</span>
                    <span class="mr-2 mt-1 send-mission-info-text-content">
                      {{ detailObject?.ambulanceCode }}
                    </span>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6" class="mt-n4">
              <v-card class="card-info-send-mission" elevation="0" height="5vh">
                <v-card-text>
                  <v-row>
                    <span class="mt-1 send-mission-info-title-content">شماره تماس:</span>
                    <span class="mr-2 mt-1 send-mission-info-text-content">
                      {{ detailObject?.phoneNumber }}
                    </span>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6" class="mt-n4">
              <v-card class="card-info-send-mission" elevation="0" height="5vh">
                <v-card-text>
                  <v-row>
                    <span class="mt-1 send-mission-info-title-content">تشخیص احتمالی پرستار:</span>
                    <span class="mr-2 mt-1 send-mission-info-text-content">
                      {{ detailObject?.cc }}
                    </span>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" class="mt-n4">
              <v-card class="card-info-send-mission" elevation="0" height="5vh">
                <v-card-text>
                  <v-row>
                    <span class="mt-1 send-mission-info-title-content">شکایت اصلی:</span>
                    <span class="mr-2 mt-1 send-mission-info-text-content">
                      {{ detailObject?.complaintText }}
                    </span>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" class="mt-n4">
              <v-card class="card-info-send-mission" elevation="0" height="5vh">
                <v-card-text>
                  <v-row>
                    <span class="mt-1 send-mission-info-title-content">توضیح شکایت:</span>
                    <span class="mr-2 mt-1 send-mission-info-text-content">
                      {{ detailObject?.complaintNote }}
                    </span>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" class="mt-n4">
              <v-card class="card-info-send-mission" elevation="0" height="5vh">
                <v-card-text>
                  <v-row>
                    <span class="mt-1 send-mission-info-title-content">توضیحات:</span>
                    <span class="mr-2 mt-1 send-mission-info-text-content">
                      {{ detailObject?.note }}
                    </span>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-row>
                <span>موقعیت</span>
                <v-divider class="mt-3 mr-3"></v-divider>
              </v-row>
            </v-col>
            <v-col cols="12" class="mt-n4">
              <v-card class="card-info-send-mission" elevation="0" height="5vh">
                <v-card-text>
                  <v-row>
                    <span class="mt-1 send-mission-info-title-content">آدرس:</span>
                    <span class="mr-2 mt-1 send-mission-info-text-content">
                      {{ detailObject?.address }}
                    </span>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <div id="map">
                <l-map v-if="isMapReadyToShow" ref="modalmap" style="height: 30vh !important" :zoom="zoom"
                  :center="center" :options="mapOptions" @update:center="centerUpdate" @update:zoom="zoomUpdate"
                  @ready="mapInvalidate()">
                  <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>
                  <l-marker v-if="missionLatitude && missionLongitude" visible :icon="icon"
                    :lat-lng.sync="position"></l-marker>
                </l-map>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">پرونده ها</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="3" class="mr-n11">
              <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense
                v-model="searchTitle" class="mt-3 mr-n16"></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="1" class="mt-4 text-left ml-5">
              <v-icon class="ml-2" color="darkColor" v-if="!soundIsPlay">mdi-play-circle</v-icon>
              <v-icon class="ml-2" color="darkColor" v-if="soundIsPlay" @click="stopMusic()">
                mdi-stop
              </v-icon>
              <v-icon class="ml-2" color="darkColor" @click="reloadData()">mdi-cached</v-icon>
            </v-col>
          </v-row>
          <v-row no-gutters class="background-main mx-2">
            <v-col cols="12">
              <v-card elevation="0" class="body-card card-width">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <template>
                        <v-data-table fixed-header :headers="otherOrganizationTableInformationHeader"
                          :items="otherOrganizationMissions" :items-per-page="otherOrganizationMissions.length"
                          height="67vh" :item-class="itemRowBackground" :search="searchTitle"
                          :hide-default-footer="true" multi-sort class="elevation-0">
                          <template v-slot:[`item.icon`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon :color="item.color" v-bind="attrs" v-on="on">
                                  mdi-ambulance mdi-18px
                                </v-icon>
                              </template>
                              <span>وضعیت {{ item.missionRank }}</span>
                            </v-tooltip>
                          </template>
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-icon class="mt-1 mx-2" color="iconColor" style="cursor: pointer"
                              @click="showDetailModal(item)">
                              mdi-information
                            </v-icon>
                          </template>
                          <template v-slot:no-data>
                            <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                          </template>
                        </v-data-table>
                      </template>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component style="z-index: 999999999999999999999 !important" ref="snackRef" :snakTimeOut="snakTimeOut"
      :snackColor="snackColor" :snackText="snackText" :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import { latLng } from 'leaflet';
import L from 'leaflet';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

import confirmDialog from '../../components/ConfirmDialog.vue';
import AlertComponent from '../../components/AlertComponent.vue';
import SharedMap from '@/Mixins/map';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import OtherOrganizationsMissionHelper from '@/Helpers/OtherOrganization/OtherOrganizationsMissionHelper';
import MissionOtherOrganizationMixin from '@/Mixins/BaseInformation/MissionOtherOrganizationMixin';
import UserMixin from '@/Mixins/BaseInformation/UserMixin';
export default {
  name: 'OtherOrganizationMissions',
  title: 'سازمان همکار',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    confirmDialog,
    AlertComponent,
    LMap,
    LTileLayer,
    LMarker,
  },
  mixins: [
    ShearedMixin,
    snackBar,
    ShearedHelper,
    OtherOrganizationsMissionHelper,
    MissionOtherOrganizationMixin,
    UserMixin,
    SharedMap,
  ],
  created() {
    this.$root.$refs.OtherOrganizationMissions = this;
    /*this.$mainSignalr.bus.$on("HospitalMainList", this.fHospitalMainList);
  this.$mobileSignalr.bus.$on("HospitalMainList", this.fHospitalMainList);*/
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {
      withPopup: latLng(30.2839, 57.0834),
      withTooltip: latLng(30.2839, 57.0834),
      currentZoom: 12,
      currentCenter: latLng(30.2839, 57.0834),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      position: null,
      dragging: false,
      icon: this.getIcon,
    };
  },
  beforeDestroy() {
    clearInterval(this.playInterval);
    this.playInterval = null;
  },
  methods: {
    mounte: function () {
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('@/assets/images/marker-icon-2x.png'),
        iconUrl: require('@/assets/images/marker-icon.png'),
        shadowUrl: require('@/assets/images/marker-shadow.png'),
      });
      this.getAllActiveMissionOtherOrganizations();
      this.setMapBaseSystemSetting();
    },
    fHospitalMainList: function () {
      clearInterval(this.playInterval);
      this.soundIsPlay = false;
      this.redFlag = false;
      this.yellowFlag = false;
      this.playInterval = null;
      this.getAllActiveMissionOtherOrganizations();
    },
    //map
    centerUpdate(center) {
      this.currentCenter = center;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    mapInvalidate: function () {
      setTimeout(() => {
        this.$refs.modalmap.mapObject.invalidateSize();
      }, 100);
    },
    addMarker(event) {
      this.position = event.latlng;
    },
  },
};
</script>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.card-add-phoneNumber {
  border: 2px solid #cdcbcf !important;
}

.card-add-phoneNumber-items {
  margin-top: -7px !important;
}

.card-add-phoneNumber-items-text {
  color: #cdcbcf !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}

.inside-cards {
  border: 1px solid var(--dark-color) !important;
  overflow-y: auto !important;
}

.dialog-part-divider-text {
  color: #212121;
  font-size: 14px;
  font-weight: 600;
}

.chip-text {
  color: var(--dark-color) !important;
}


>>>.row-back-red {
  background-color: #ffafaf !important;
}

>>>.row-back-yellow {
  background-color: #ffe290 !important;
}

.card-info-send-mission {
  border-right: 3px solid var(--dark-color) !important;
  border-left: 3px solid var(--dark-color) !important;
  border-top: 2px solid var(--background-color) !important;
  border-bottom: 2px solid var(--background-color) !important;
  border-radius: 10px !important;
}

.send-mission-info-title-content {
  color: #212121 !important;
  font-weight: 500;
  font-size: 14px;
}

.send-mission-info-text-content {
  color: #212121 !important;
  font-weight: 400;
  font-size: 12px;
}
</style>
